import { Model } from "vue-mc";

export class Lada extends Model {
  defaults() {
    return {
      clave: null
      , lada: ""
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , lada: (lada) => lada
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/models/geograficos/lada.js